import { render, staticRenderFns } from "./Chars.vue?vue&type=template&id=409049c8&scoped=true&"
import script from "./Chars.vue?vue&type=script&lang=js&"
export * from "./Chars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409049c8",
  null
  
)

export default component.exports